import React from "react";
import { Text } from "../../atoms/text/text";
import styles from "./channel-search.module.css";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * SR8's Reset Search — right-aligned above the field, painted as a link and
 * announced as a button, because it operates the page rather than navigating.
 *
 * It stays visible with nothing typed and nothing selected (Figma), so there
 * is no "enabled" state to compute: the control either exists, because the
 * content team named it, or it does not.
 *
 * ⚠ NOT `atoms/link`. A link that goes nowhere is the WCAG 4.1.2 failure this
 * avoids; the link COLOUR is the whole of the resemblance (WAT-12498 took the
 * underline off, because the frame draws none — see `.reset` in the sheet).
 */
export interface ResetControlProps {
  label: string;
  /** Internal to this folder, not part of the molecule's published surface. */
  onReset: () => void;
}

function ResetControlImpl({ label, onReset }: ResetControlProps) {
  return (
    <div className={styles.resetRow}>
      <button className={styles.reset} onClick={onReset} type="button">
        {/* WAT-12498 — the class is what lets the button's colour reach the
            wording: `Text` always emits `dds-tone-primary`, which paints the
            span itself. See `.resetLabel` in `channel-search.module.css`. */}
        <Text as="span" className={styles.resetLabel} variant="text-link-3" weight="medium">
          {label}
        </Text>
      </button>
    </div>
  );
}
export const ResetControl = withSafeRender(ResetControlImpl, "ResetControl");

export default ResetControl;
